import { LanguageInfo } from "../types";
// Language information including name, code, and flag emoji
export const languages: LanguageInfo[] = [
  { name: "English", code: "en", flag: "🇺🇸" },
  { name: "Français", code: "fr", flag: "🇫🇷" },
];

// Translation keys for all UI elements
const translations: any = {
  en: {
    // Navigation (Add these if not in your NavBar component)
    nav_brand: "FUKKONI", // Added key for brand/logo text
    nav_home: "Home",
    nav_features: "Features",
    nav_pricing: "Pricing",
    nav_about: "About", // Added About link key
    nav_contact: "Contact",

    // Hero Section
    hero_newFeatures_badge: "New Dashboard Features Available",
    hero_title_part1: "Transform Your",
    hero_title_part2: "Store Management", // This part has the gradient
    hero_description:
      "Streamline operations, boost efficiency, and scale your business with our intelligent store management platform.",
    hero_button_getStarted: "Get Started",
    hero_button_watchDemo: "Watch Demo",
    hero_trustedBy: "Trusted by",
    hero_businesses: "businesses",
    hero_stats_monthlySales: "Monthly Sales", // Text in the floating card

    // Features Section
    features_badge: "Powerful Capabilities",
    features_title_part1: "Everything You Need to",
    features_title_part2: "Manage Your Store", // This part has the gradient
    features_description:
      "Powerful features designed to help you grow your business and streamline operations",

    features_inventory_title: "Inventory Management",
    features_inventory_description:
      "Real-time tracking and automated reordering system to prevent stockouts and optimize inventory levels.",

    features_analytics_title: "Advanced Analytics", // Added title key
    features_analytics_description:
      "Comprehensive reports and business insights that help you make data-driven decisions for growth.",

    features_customer_title: "Customer Management", // Added title key
    features_customer_description:
      "Track customer behavior and preferences to personalize their shopping experience and boost loyalty.",

    features_integration_title: "Easy Integration", // Added title key
    features_integration_description:
      "Seamless integration with existing systems including e-commerce platforms, payment gateways, and more.",

    features_updates_title: "Real-time Updates", // Added title key
    features_updates_description:
      "Instant synchronization across all devices ensuring your team always has the latest information.",

    features_security_title: "Secure Platform", // Added title key
    features_security_description:
      "Enterprise-grade security for your data with regular backups and advanced encryption protocols.",

    features_button_seePricing: "See our pricing plans",

    // Pricing Section
    pricing_badge: "Flexible Plans For Everyone",
    pricing_title_part1: "Simple, Transparent",
    pricing_title_part2: "Pricing", // This part has the gradient
    pricing_description:
      "Choose the plan that best fits your business needs with no hidden fees",

    pricing_plan_mostPopular: "Most Popular", // Badge text
    pricing_plan_month: "month", // Text next to price

    // Plan names (using keys for consistency)
    plan_starter_name: "Starter",
    plan_professional_name: "Professional",
    plan_enterprise_name: "Enterprise",

    // Plan features (using keys)
    feature_products_1k: "Up to 1,000 products",
    feature_products_10k: "Up to 10,000 products",
    feature_products_unlimited: "Unlimited products",

    feature_analytics_basic: "Basic analytics",
    feature_analytics_advanced: "Advanced analytics", // Added advanced analytics key
    feature_analytics_custom: "Custom analytics",

    feature_users_2: "2 user accounts",
    feature_users_5: "5 user accounts",
    feature_users_unlimited: "Unlimited users",

    feature_support_email: "Email support",
    feature_support_priority: "Priority support",
    feature_support_24_7: "24/7 support",

    feature_access_mobile: "Mobile app access",
    feature_access_api: "API access",
    feature_integration_custom: "Custom integration",

    feature_reports_custom: "Custom reports",
    feature_account_manager: "Dedicated account manager",

    pricing_customPlan_cta_part1: "Need a custom plan for your enterprise?",
    pricing_customPlan_cta_part2: "Contact us", // The link text

    // Contact Section
    contact_badge: "Contact Us",
    contact_title_part1: "Get in",
    contact_title_part2: "Touch", // This part has the gradient (assuming "With Us" is removed or part of description)
    contact_description:
      "Have questions or need assistance? Our team is here to help you.",

    contact_form_name_label: "Full Name",
    contact_form_name_placeholder: "John Doe",
    contact_form_email_label: "Email Address",
    contact_form_email_placeholder: "john@example.com",
    contact_form_message_label: "Message",
    contact_form_message_placeholder: "How can we help you?",
    contact_form_button_sending: "Sending...",
    contact_form_button_sendMessage: "Send Message",
    contact_form_success_title: "Message Sent!",
    contact_form_success_message: "We'll get back to you as soon as possible.",

    contact_info_title: "Contact Information",
    contact_info_email_label: "Email", // Label for email info
    contact_info_phone_label: "Phone", // Label for phone info
    contact_info_office_label: "Office", // Label for office info
    contact_info_email_address: "nankim45@gmail.com", // Actual email, often not translated but can be
    contact_info_phone_number: "(250) 782 015 589", // Actual phone, often not translated
    contact_info_office_address_line1: "Gisimeti", // Address lines
    contact_info_office_address_line2: "Remera",
    contact_info_office_address_line3: "Kigali, KG 37 B",

    // Footer Section
    footer_brand_description:
      "Transforming store management with innovative solutions. Our platform helps businesses streamline operations and scale efficiently.",
    footer_back_to_top_aria: "Back to top",
    footer_follow_us_aria: "Follow us on",
    footer_title_product: "Product",
    footer_title_company: "Company",
    footer_title_support: "Support",
    footer_link_integration: "Integration",
    footer_link_documentation: "Documentation",
    footer_link_updates: "Updates",
    footer_link_careers: "Careers",
    footer_link_blog: "Blog",
    footer_link_partners: "Partners",
    footer_link_helpCenter: "Help Center",
    footer_link_terms: "Terms of Service",
    footer_link_privacy: "Privacy Policy",
    footer_link_status: "Status",
    footer_link_contactSupport: "Contact Support",
    footer_copyright_allRightsReserved: "All rights reserved.",

    // Navbar ARIA labels
    nav_open_menu_aria: "Open main menu",
    nav_close_menu_aria: "Close main menu",
  },
  // Add other languages (fr, es, rw) with corresponding translations
  fr: {
    // Navigation
    nav_brand: "FUKKONI", // Keep brand name often untranslated
    nav_home: "Accueil",
    nav_features: "Fonctionnalités",
    nav_pricing: "Tarifs",
    nav_about: "À Propos",
    nav_contact: "Contact",

    // Hero Section
    hero_newFeatures_badge:
      "Nouvelles fonctionnalités du tableau de bord disponibles",
    hero_title_part1: "Transformez Votre",
    hero_title_part2: "Gestion de Magasin",
    hero_description:
      "Simplifiez les opérations, augmentez l'efficacité et développez votre entreprise avec notre plateforme de gestion de magasin intelligente.",
    hero_button_getStarted: "Commencer",
    hero_button_watchDemo: "Regarder la démo",
    hero_trustedBy: "Approuvé par",
    hero_businesses: "entreprises",
    hero_stats_monthlySales: "Ventes Mensuelles",

    // Features Section
    features_badge: "Capacités Puissantes",
    features_title_part1: "Tout ce dont vous avez besoin pour",
    features_title_part2: "Gérer Votre Magasin",
    features_description:
      "Fonctionnalités puissantes conçues pour vous aider à développer votre entreprise et à rationaliser les opérations",

    features_inventory_title: "Gestion des Stocks",
    features_inventory_description:
      "Suivi en temps réel et système de réapprovisionnement automatisé pour prévenir les ruptures de stock et optimiser les niveaux de stock.",

    features_analytics_title: "Analyses Avancées",
    features_analytics_description:
      "Des rapports complets et des informations commerciales qui vous aident à prendre des décisions basées sur les données pour la croissance.",

    features_customer_title: "Gestion de la Clientèle",
    features_customer_description:
      "Suivez le comportement et les préférences des clients pour personnaliser leur expérience d'achat et renforcer la fidélité.",

    features_integration_title: "Intégration Facile",
    features_integration_description:
      "Intégration transparente avec les systèmes existants, y compris les plateformes de commerce électronique, les passerelles de paiement, etc.",

    features_updates_title: "Mises à Jour en Temps Réel",
    features_updates_description:
      "Synchronisation instantanée sur tous les appareils, garantissant que votre équipe dispose toujours des informations les plus récentes.",

    features_security_title: "Plateforme Sécurisée",
    features_security_description:
      "Sécurité de niveau entreprise pour vos données avec des sauvegardes régulières et des protocoles de cryptage avancés.",

    features_button_seePricing: "Voir nos plans tarifaires",

    // Pricing Section
    pricing_badge: "Plans Flexibles Pour Tous",
    pricing_title_part1: "Tarifs Simples,",
    pricing_title_part2: "Transparents",
    pricing_description:
      "Choisissez le plan qui convient le mieux aux besoins de votre entreprise sans frais cachés",

    pricing_plan_mostPopular: "Le Plus Populaire",
    pricing_plan_month: "mois",

    // Plan names
    plan_starter_name: "Débutant",
    plan_professional_name: "Professionnel",
    plan_enterprise_name: "Entreprise",

    // Plan features
    feature_products_1k: "Jusqu'à 1 000 produits",
    feature_products_10k: "Jusqu'à 10 000 produits",
    feature_products_unlimited: "Produits illimités",

    feature_analytics_basic: "Analyses de base",
    feature_analytics_advanced: "Analyses avancées",
    feature_analytics_custom: "Analyses personnalisées",

    feature_users_2: "2 comptes d'utilisateurs",
    feature_users_5: "5 comptes d'utilisateurs",
    feature_users_unlimited: "Utilisateurs illimités",

    feature_support_email: "Support par e-mail",
    feature_support_priority: "Support prioritaire",
    feature_support_24_7: "Support 24/7",

    feature_access_mobile: "Accès à l'application mobile",
    feature_access_api: "Accès API",
    feature_integration_custom: "Intégration personnalisée",

    feature_reports_custom: "Rapports personnalisés",
    feature_account_manager: "Responsable de compte dédié",

    pricing_customPlan_cta_part1:
      "Besoin d'un plan personnalisé pour votre entreprise ?",
    pricing_customPlan_cta_part2: "Contactez-nous",

    // Contact Section
    contact_badge: "Nous Contacter",
    contact_title_part1: "Prenez",
    contact_title_part2: "Contact",
    contact_description:
      "Vous avez des questions ou avez besoin d'aide ? Notre équipe est là pour vous aider.",

    contact_form_name_label: "Nom Complet",
    contact_form_name_placeholder: "Jean Dupont",
    contact_form_email_label: "Adresse E-mail",
    contact_form_email_placeholder: "jean@exemple.com",
    contact_form_message_label: "Message",
    contact_form_message_placeholder: "Comment pouvons-nous vous aider ?",
    contact_form_button_sending: "Envoi...",
    contact_form_button_sendMessage: "Envoyer le Message",
    contact_form_success_title: "Message Envoyé !",
    contact_form_success_message: "Nous vous répondrons dès que possible.",

    contact_info_title: "Informations de Contact",
    contact_info_email_label: "E-mail",
    contact_info_phone_label: "Téléphone",
    contact_info_office_label: "Bureau",
    contact_info_email_address: "nankim45@gmail.com",
    contact_info_phone_number: "(250) 782 015 589",
    contact_info_office_address_line1: "Gisimeti",
    contact_info_office_address_line2: "Remera",
    contact_info_office_address_line3: "Kigali, KG 37 B",

    // Footer Section
    footer_brand_description:
      "Transformation de la gestion des magasins avec des solutions innovantes. Notre plateforme aide les entreprises à rationaliser leurs opérations et à évoluer efficacement.",
    footer_back_to_top_aria: "Retour en haut de page",
    footer_follow_us_aria: "Suivez-nous sur",
    footer_title_product: "Produit",
    footer_title_company: "Entreprise",
    footer_title_support: "Support",
    footer_link_integration: "Intégration",
    footer_link_documentation: "Documentation",
    footer_link_updates: "Mises à Jour",
    footer_link_careers: "Carrières",
    footer_link_blog: "Blog",
    footer_link_partners: "Partenaires",
    footer_link_helpCenter: "Centre d'Aide",
    footer_link_terms: "Conditions d'Utilisation",
    footer_link_privacy: "Politique de Confidentialité",
    footer_link_status: "Statut",
    footer_link_contactSupport: "Contacter le Support",
    footer_copyright_allRightsReserved: "Tous droits réservés.",

    // Navbar ARIA labels
    nav_open_menu_aria: "Ouvrir le menu principal",
    nav_close_menu_aria: "Fermer le menu principal",
  },
  // ... add es and rw translations following the same structure
};

export default translations;
